/* Spencer Go mobile bars: estimator, quote form, availability calendar. One script for every .smb section on the page. */
(() => {
function initSpencerGo(root) {
  if (!root || root.dataset.ready) return;
  const cfgEl = root.querySelector('script[data-smb-config]');
  if (!cfgEl) return;
  root.dataset.ready = '1';
  const cfg = JSON.parse(cfgEl.textContent);
  const $ = (q, el = root) => el.querySelector(q);
  const $$ = (q, el = root) => Array.from(el.querySelectorAll(q));
  const rand = (n) => 'R' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const LABEL = { coffee: 'Coffee', matcha: 'Matcha', smoothie: 'Smoothie' };
  const pkgs = cfg.packages.map(p => ({ ...p, price: +p.price, drinks: +p.drinks, hours: +p.hours }));
  const barsOf = (sel) => String(sel || 'coffee').split('+').filter(b => LABEL[b]);
  const track = (event, data = {}) => {
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'smb_' + event, ...data }); } catch (_) {}
    try { window._hsq && window._hsq.push(['trackCustomBehavioralEvent', { name: 'smb_' + event, properties: data }]); } catch (_) {}
  };

  /* ---------- Tabs ---------- */
  const tabs = $$('[data-smb-tab]');
  const showTab = (bar, focus) => {
    tabs.forEach(t => { const on = t.dataset.smbTab === bar; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
    $$('[data-smb-panel]').forEach(p => p.hidden = p.dataset.smbPanel !== bar);
  };
  tabs.forEach((t, i) => {
    t.addEventListener('click', () => showTab(t.dataset.smbTab));
    t.addEventListener('keydown', e => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
      showTab(next.dataset.smbTab, true);
    });
  });
  $$('[data-smb-show]').forEach(a => a.addEventListener('click', () => showTab(a.dataset.smbShow)));

  /* ---------- Pricing engine (estimator + form share it) ----------
     Demand: drinks per guest rises with service length. With two bars, guests split their
     orders, so ~60% of single-bar demand lands on each bar. Extra cups bill at the bar's
     per-cup rate. Pairing takes the combo discount off both package prices (not extras). */
  const drinksPerGuest = (hours) => hours >= 6 ? 1.6 : hours >= 4 ? 1.3 : 1.0;
  const PAIR_SHARE = 0.6;
  function pick(bar, guests, hours, share = 1) {
    const all = pkgs.filter(p => p.bar === bar);
    if (!all.length) return null;
    const need = Math.ceil(guests * drinksPerGuest(hours) * share);
    const rate = +cfg.rates[bar] || 0;
    const fits = all.filter(p => p.hours >= hours);
    const pool = fits.length ? fits : all;
    return pool.map(pkg => { const extras = Math.max(0, need - pkg.drinks); return { pkg, need, extras, extraCost: extras * rate, subtotal: pkg.price + extras * rate }; })
      .sort((a, b) => a.subtotal - b.subtotal || b.pkg.drinks - a.pkg.drinks)[0];
  }
  function estimate({ bar, guests, hours, zone, canning }) {
    const bars = barsOf(bar);
    const paired = bars.length > 1;
    const parts = bars.map(b => ({ bar: b, ...pick(b, guests, hours, paired ? PAIR_SHARE : 1) })).filter(p => p.pkg);
    const pkgTotal = parts.reduce((s, p) => s + p.pkg.price, 0);
    const extrasTotal = parts.reduce((s, p) => s + p.extraCost, 0);
    const discount = paired ? Math.round(pkgTotal * (+cfg.comboDiscount || 0) / 100) : 0;
    const canCups = canning ? parts.filter(p => cfg.canningBars.includes(p.bar)).reduce((s, p) => s + Math.max(p.need, p.pkg.drinks), 0) : 0;
    const canningTotal = canCups * (+cfg.canningFee || 0);
    const travel = (+(cfg.zones[zone] || {}).fee || 0) * parts.length;
    const crew = paired ? 3 : 2;
    return { parts, pkgTotal, extrasTotal, discount, canCups, canningTotal, travel, crew, total: pkgTotal + extrasTotal - discount + canningTotal + travel };
  }

  /* ---------- Estimator UI ---------- */
  const est = $('[data-smb-estimator]');
  const state = { bar: 'coffee', guests: 100, hours: 3, zone: 'A', canning: false, packageId: '' };
  const partLabel = (p) => `${LABEL[p.bar]} ${p.pkg.name}`;
  function renderEstimate() {
    const r = estimate(state);
    $('[data-smb-out="guests"]').textContent = state.guests;
    $('[data-smb-out="total"]').textContent = rand(r.total);
    $('[data-smb-out="pkg"]').textContent = r.parts.map(partLabel).join('  +  ') + ` · ${r.crew} baristas`;
    const rows = [];
    r.parts.forEach(p => rows.push([`${partLabel(p)} (${p.pkg.drinks} cups)`, rand(p.pkg.price)]));
    r.parts.filter(p => p.extras).forEach(p => rows.push([`${p.extras} extra ${LABEL[p.bar].toLowerCase()} cups`, rand(p.extraCost)]));
    if (r.discount) rows.push([`Pairing saving (${cfg.comboDiscount}%)`, '−' + rand(r.discount), true]);
    if (r.canningTotal) rows.push([`Canning bar (${r.canCups} cans)`, rand(r.canningTotal)]);
    if (state.canning && !r.canningTotal) rows.push(['Canning on iced coffees', 'on quote']);
    rows.push([`Travel · zone ${state.zone}${r.parts.length > 1 ? ' × 2 bars' : ''}`, rand(r.travel)]);
    $('[data-smb-out="lines"]').innerHTML = rows.map(([k, v, save]) => `<dt>${k}</dt><dd${save ? ' class="smb-result__save"' : ''}>${v}</dd>`).join('');
    const z = cfg.zones[state.zone]; $('[data-smb-zonehint]').textContent = z ? z.label : '';
    const sticky = $('[data-smb-out="sticky"]'); if (sticky) sticky.textContent = `Estimate ${rand(r.total)} · ${state.guests} guests`;
    return r;
  }
  est.addEventListener('input', e => {
    const f = new FormData(est);
    state.bar = f.get('bar'); state.guests = +f.get('guests'); state.hours = +f.get('hours'); state.zone = f.get('zone'); state.canning = !!f.get('canning');
    renderEstimate();
    if (e.target.name !== 'guests') track('estimate_change', { bar: state.bar });
  });
  renderEstimate();

  /* ---------- Quote form ---------- */
  const form = $('[data-smb-form]');
  const pkgSelect = form.elements.package;
  let step = 1;
  const selBar = () => form.querySelector('[name="bar_type"]:checked').value;
  function fillPackages() {
    const bars = barsOf(selBar());
    const list = pkgs.filter(p => bars.includes(p.bar));
    const keep = state.packageId;
    pkgSelect.innerHTML = '<option value="">Recommend for me</option>' + list.map(p =>
      `<option value="${p.id}">${LABEL[p.bar]} ${p.name} · ${rand(p.price)} · ${p.drinks} cups</option>`).join('');
    if (list.some(p => p.id === keep)) pkgSelect.value = keep;
    summary();
  }
  function summary() {
    const bar = selBar();
    const guests = +form.elements.guest_count.value || state.guests;
    const canning = form.querySelector('[name="addons"][value="Canning bar"]').checked;
    const chosen = pkgs.find(p => p.id === pkgSelect.value);
    let r;
    if (chosen && barsOf(bar).length === 1) {
      const need = Math.ceil(guests * drinksPerGuest(state.hours));
      const extras = Math.max(0, need - chosen.drinks);
      const cans = canning && cfg.canningBars.includes(chosen.bar) ? Math.max(need, chosen.drinks) * (+cfg.canningFee || 0) : 0;
      r = { total: chosen.price + extras * (+cfg.rates[chosen.bar] || 0) + cans + (+(cfg.zones[state.zone] || {}).fee || 0), label: `${LABEL[chosen.bar]} ${chosen.name}` };
    } else {
      const e = estimate({ ...state, bar, guests, canning });
      r = { total: e.total, label: e.parts.map(partLabel).join(' + ') };
    }
    form.dataset.estimate = Math.round(r.total);
    form.dataset.pkgLabel = r.label;
    $('[data-smb-summary]').innerHTML = `Estimated: <b>${rand(r.total)}</b> · ${r.label} · ${guests} guests · incl. travel. Final figure on your written quote.`;
  }
  form.addEventListener('change', e => { if (e.target.name === 'bar_type') fillPackages(); else summary(); });

  $$('[data-smb-pick]').forEach(a => a.addEventListener('click', () => {
    const p = pkgs.find(x => x.id === a.dataset.smbPick); if (!p) return;
    state.packageId = p.id;
    form.querySelector(`[name="bar_type"][value="${p.bar}"]`).checked = true;
    fillPackages(); track('package_pick', { package: p.name, bar: p.bar });
  }));
  $$('[data-smb-track="estimate_continue"], [data-smb-track="hero_quote"]').forEach(a => a.addEventListener('click', () => {
    form.elements.guest_count.value = state.guests;
    const b = form.querySelector(`[name="bar_type"][value="${state.bar}"]`); if (b) b.checked = true;
    const c = form.querySelector('[name="addons"][value="Canning bar"]'); if (c) c.checked = state.canning;
    fillPackages(); track(a.dataset.smbTrack);
  }));

  const rules = {
    1: { event_date: v => !v ? 'Pick a date' : (new Date(v + 'T12:00') < minDate() ? `We need at least ${cfg.leadDays} days’ notice` : ''),
         event_type: v => v ? '' : 'Choose an event type',
         guest_count: v => (+v >= 10 && +v <= 5000) ? '' : 'Between 10 and 5,000 guests',
         venue: v => v.trim().length >= 3 ? '' : 'Tell us where the event is' },
    2: {},
    3: { firstname: v => v.trim() ? '' : 'Required', lastname: v => v.trim() ? '' : 'Required',
         email: v => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()) ? '' : 'Enter a valid email',
         phone: v => v.replace(/[^\d]/g, '').length >= 9 ? '' : 'Enter a valid number',
         consent: (_, el) => el.checked ? '' : 'Please accept so we can contact you' }
  };
  function validate(n) {
    let firstBad = null;
    Object.entries(rules[n]).forEach(([name, fn]) => {
      const el = form.elements[name]; const msg = fn(el.type === 'checkbox' ? '' : el.value, el);
      el.setAttribute('aria-invalid', msg ? 'true' : 'false');
      const box = form.querySelector(`[data-err="${name}"]`); if (box) box.textContent = msg;
      if (msg && !firstBad) firstBad = el;
    });
    if (firstBad) firstBad.focus();
    return !firstBad;
  }
  function go(n) {
    step = n;
    $$('fieldset[data-step]', form).forEach(f => f.hidden = +f.dataset.step !== n);
    $$('[data-step-ind]', form).forEach(li => li.dataset.state = +li.dataset.stepInd < n ? 'done' : +li.dataset.stepInd === n ? 'active' : '');
    $('[data-smb-back]').hidden = n === 1;
    $('[data-smb-next]').hidden = n === 3;
    $('[data-smb-submit]').hidden = n !== 3;
    if (n === 2) fillPackages();
    const lg = form.querySelector(`fieldset[data-step="${n}"] legend`); if (lg) { lg.tabIndex = -1; lg.focus({ preventScroll: true }); }
    track('form_step', { step: n });
  }
  $('[data-smb-next]').addEventListener('click', () => { if (validate(step)) go(step + 1); });
  $('[data-smb-back]').addEventListener('click', () => go(step - 1));

  const ss = { get(k) { try { return sessionStorage.getItem(k); } catch (_) { return null; } }, set(k, v) { try { sessionStorage.setItem(k, v); } catch (_) {} } };
  const cookie = (k) => (document.cookie.match('(?:^|; )' + k + '=([^;]*)') || [])[1];
  const utm = (() => { const p = new URLSearchParams(location.search); const o = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'].forEach(k => { const v = p.get(k) || ss.get('smb_' + k); if (v) { o[k] = v; ss.set('smb_' + k, v); } });
    return o; })();

  function payload() {
    const f = new FormData(form);
    const chosen = pkgs.find(p => p.id === f.get('package'));
    return {
      firstname: f.get('firstname').trim(), lastname: f.get('lastname').trim(), email: f.get('email').trim(),
      phone: f.get('phone').trim(), company: (f.get('company') || '').trim(),
      event_date: f.get('event_date'), start_time: f.get('start_time') || '', event_type: f.get('event_type'),
      guest_count: +f.get('guest_count'), venue: f.get('venue').trim(), travel_zone: state.zone,
      bar_type: f.get('bar_type'), package: chosen ? `${chosen.bar} ${chosen.name}` : (form.dataset.pkgLabel || 'Recommend'),
      addons: f.getAll('addons'), budget: f.get('budget') || '', message: (f.get('message') || '').trim(),
      estimate_zar: +form.dataset.estimate || 0, consent: !!f.get('consent'), website: f.get('website') || '',
      context: { hutk: cookie('hubspotutk') || '', pageUri: location.href, pageName: document.title, ...utm }
    };
  }
  async function sendDirectToHubSpot(p) {
    const { portalId, formId } = cfg.hubspot;
    if (!portalId || !formId) throw new Error('No lead endpoint configured');
    const detail = [`Bar: ${p.bar_type}`, `Package: ${p.package}`, `Estimate: R${p.estimate_zar}`, `Start: ${p.start_time || '-'}`, `Zone: ${p.travel_zone}`,
      `Add-ons: ${p.addons.join(', ') || '-'}`, `Budget: ${p.budget || '-'}`, p.message].filter(Boolean).join('\n');
    const map = { firstname: p.firstname, lastname: p.lastname, email: p.email, phone: p.phone, company: p.company,
      mb_event_date: p.event_date, mb_event_type: p.event_type, mb_guest_count: p.guest_count,
      mb_bar_type: p.bar_type, mb_venue: p.venue, message: detail };
    const res = await fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ fields: Object.entries(map).filter(([, v]) => v !== '' && v != null).map(([name, value]) => ({ objectTypeId: '0-1', name, value: String(value) })),
        context: { hutk: p.context.hutk || undefined, pageUri: p.context.pageUri, pageName: p.context.pageName },
        legalConsentOptions: { consent: { consentToProcess: true, text: cfg.consentText } } })
    });
    if (!res.ok) throw new Error('HubSpot rejected the submission');
    return { ref: 'HS-' + Date.now().toString(36).toUpperCase() };
  }
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!validate(3)) return;
    const btn = $('[data-smb-submit]'); const err = $('[data-smb-error]');
    err.hidden = true; btn.disabled = true; btn.textContent = 'Sending…';
    const p = payload();
    try {
      let out;
      if (cfg.endpoint) {
        const res = await fetch(cfg.endpoint.replace(/\/$/, '') + '/api/lead', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(p) });
        out = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(out.error || 'Something went wrong');
      } else {
        out = await sendDirectToHubSpot(p);
      }
      track('quote_submit', { bar: p.bar_type, guests: p.guest_count, estimate: p.estimate_zar, value: p.estimate_zar, currency: 'ZAR' });
      form.hidden = true;
      const done = $('[data-smb-done]'); done.hidden = false;
      $('[data-smb-done-email]').textContent = p.email; $('[data-smb-done-ref]').textContent = out.ref || '—';
      done.focus();
    } catch (ex) {
      err.textContent = `${ex.message}. Please try again${cfg.whatsapp ? ', or WhatsApp us on ' + cfg.whatsapp : ''}.`;
      err.hidden = false; btn.disabled = false; btn.textContent = 'Request my quote';
      track('quote_error');
    }
  });

  /* ---------- Availability calendar ---------- */
  const DAY = 864e5;
  function minDate() { const d = new Date(); d.setHours(0, 0, 0, 0); return new Date(d.getTime() + (+cfg.leadDays || 0) * DAY); }
  const iso = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  const cal = { view: new Date(minDate().getFullYear(), minDate().getMonth(), 1), cache: {}, selected: '' };
  const maxView = (() => { const m = minDate(); return new Date(m.getFullYear(), m.getMonth() + (+cfg.monthsAhead || 12), 1); })();
  async function loadMonth(key) {
    if (cal.cache[key]) return cal.cache[key];
    if (!cfg.availabilityEndpoint) return (cal.cache[key] = { booked: [], limited: [], live: false });
    try {
      const r = await fetch(cfg.availabilityEndpoint.replace(/\/$/, '') + '/api/availability?month=' + key);
      const j = await r.json();
      return (cal.cache[key] = { booked: j.booked || [], limited: j.limited || [], live: true });
    } catch (_) { return (cal.cache[key] = { booked: [], limited: [], live: false }); }
  }
  async function renderCal() {
    const y = cal.view.getFullYear(), m = cal.view.getMonth();
    const key = `${y}-${String(m + 1).padStart(2, '0')}`;
    $('[data-smb-cal-title]').textContent = cal.view.toLocaleDateString('en-ZA', { month: 'long', year: 'numeric' });
    $('[data-smb-cal-prev]').disabled = cal.view <= new Date(minDate().getFullYear(), minDate().getMonth(), 1);
    $('[data-smb-cal-next]').disabled = cal.view >= maxView;
    const grid = $('[data-smb-cal-grid]');
    grid.innerHTML = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(d => `<div class="smb-cal__dow" role="columnheader">${d}</div>`).join('') + '<div class="smb-day smb-day--empty"></div>'.repeat((new Date(y, m, 1).getDay() + 6) % 7);
    const data = await loadMonth(key);
    const days = new Date(y, m + 1, 0).getDate(); const min = minDate(); let html = '';
    for (let d = 1; d <= days; d++) {
      const date = new Date(y, m, d); const k = iso(date);
      const past = date < min; const booked = data.booked.includes(k); const limited = data.limited.includes(k);
      const label = date.toLocaleDateString('en-ZA', { weekday: 'long', day: 'numeric', month: 'long' }) + (booked ? ', fully booked' : limited ? ', limited availability' : past ? ', unavailable' : ', available');
      html += `<button type="button" class="smb-day${limited ? ' smb-day--limited' : ''}" data-date="${k}" data-nice="${date.toLocaleDateString('en-ZA', { weekday: 'short', day: 'numeric', month: 'short' })}" aria-label="${label}" aria-pressed="${cal.selected === k}" ${past || booked ? 'disabled' : ''}>${d}</button>`;
    }
    grid.insertAdjacentHTML('beforeend', html);
    $('[data-smb-cal-status]').textContent = data.live ? '' : 'Live availability is loading slowly. Pick a date and we’ll confirm it.';
  }
  $('[data-smb-cal-grid]').addEventListener('click', e => {
    const b = e.target.closest('[data-date]'); if (!b || b.disabled) return;
    cal.selected = b.dataset.date;
    $$('[data-date]').forEach(x => x.setAttribute('aria-pressed', x === b));
    form.elements.event_date.value = cal.selected;
    form.elements.event_date.setAttribute('aria-invalid', 'false');
    form.querySelector('[data-err="event_date"]').textContent = '';
    const limited = b.classList.contains('smb-day--limited');
    $('[data-smb-cal-status]').textContent = limited ? `${b.dataset.nice}: one bar left. Request soon.` : `${b.dataset.nice} is open. Added to your request.`;
    track('date_pick', { limited });
  });
  form.elements.event_date.min = iso(minDate());
  form.elements.event_date.addEventListener('change', e => {
    const v = e.target.value; if (!v) return; const d = new Date(v + 'T12:00');
    cal.selected = v; cal.view = new Date(d.getFullYear(), d.getMonth(), 1); renderCal();
  });
  $('[data-smb-cal-prev]').addEventListener('click', () => { cal.view = new Date(cal.view.getFullYear(), cal.view.getMonth() - 1, 1); renderCal(); });
  $('[data-smb-cal-next]').addEventListener('click', () => { cal.view = new Date(cal.view.getFullYear(), cal.view.getMonth() + 1, 1); renderCal(); });
  renderCal();

  /* ---------- HubSpot Meetings (lazy) ---------- */
  const mBtn = $('[data-smb-meetings]');
  if (mBtn) mBtn.addEventListener('click', () => {
    const t = $('[data-smb-meetings-target]');
    t.innerHTML = `<div class="meetings-iframe-container" data-src="${mBtn.dataset.smbMeetings}?embed=true"></div>`;
    const sc = document.createElement('script'); sc.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js'; sc.async = true; document.body.appendChild(sc);
    mBtn.hidden = true; track('meeting_open');
  });

  /* ---------- Sticky mobile CTA ---------- */
  const sticky = $('[data-smb-sticky]'); const book = $('.smb-book');
  if (sticky && 'IntersectionObserver' in window) {
    let pastHero = false, inBook = false;
    const sync = () => sticky.classList.toggle('is-visible', pastHero && !inBook);
    new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting; sync(); }).observe($('.smb-hero'));
    new IntersectionObserver(([e]) => { inBook = e.isIntersecting; sync(); }, { threshold: 0.05 }).observe(book);
  }

  fillPackages();
  root.__smb = { estimate, pick };   // exposed for tests
}
document.querySelectorAll('[data-smb]').forEach(initSpencerGo);
/* Re-init when the section is re-rendered in the theme editor */
document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-smb]').forEach(initSpencerGo));
})();
